import React from "react";
import styled from "styled-components";

const HiringProcess = () => {
  return (
    <StyledHiringProcess>
      <div className="section-wrapper home_parent_wrapper">
        <div className="traditional_process_wrapper">
          <h3>
            Traditional Recruitment Process without <span>Profiles</span>
          </h3>
          <div id="scrollbar" className="traditional_process">
            <div className="traditional_process_text">
              Job Advertisements
              <div className="traditional_process_divider"></div>
            </div>
            <div className="traditional_process_text">
              Resume <br /> screening
              <div className="traditional_process_divider"></div>
            </div>
            <div className="traditional_process_text">
              Pre-Screening
              <div className="traditional_process_divider"></div>
            </div>
            <div className="traditional_process_text">
              Assessment
              <div className="traditional_process_divider"></div>
            </div>
            <div className="traditional_process_text">
              Interviews/ Selection
              <div className="traditional_process_divider"></div>
            </div>
            <div className="traditional_process_text">Job Offer</div>
          </div>
        </div>
        <div className="profiles_process_wrapper">
          <h3>
            What your hiring process will look like with <span>Profiles</span>
          </h3>
          <div id="scrollbar" className="profiles_process">
            <div className="profiles_process_text">
              Assessment
              <div className="profiles_process_divider"></div>
            </div>
            <div className="profiles_process_text">
              Interviews / Selection
              <div className="profiles_process_divider"></div>
            </div>
            <div className="profiles_process_text">Job Offer</div>
          </div>
        </div>
      </div>
    </StyledHiringProcess>
  );
};

const StyledHiringProcess = styled.section`
  .section-wrapper {
    padding: 8rem 4rem;
    background: #FEF6EE;
  }

  .traditional_process {
    margin-bottom: 8rem;
  }

  .traditional_process_wrapper h3 {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 5.6rem;
  }

  .traditional_process_wrapper span {
    color: #34a853;
  }

  .traditional_process {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 52px;
  }

  .traditional_process_text {
    position: relative;
    width: 137px;
    height: 64px;
    border: 1px solid #f9dbaf;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.15px;
    font-size: 1.6rem;
  }

  .traditional_process_divider {
    position: absolute;
    right: -47%;
    width: 6rem;
    border: 2px dashed #34a853;
  }

  .profiles_process_wrapper h3 {
    font-size: 4.8rem;
    font-weight: 700;
    text-align: center;
    margin: 0 auto 5.6rem auto;
    width: 921px;
  }

  .profiles_process_wrapper span {
    color: #34a853;
    font-style: italic;
  }

  .profiles_process {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10rem;
  }

  .profiles_process_text {
    position: relative;
    border: 1px solid #f9dbaf;
    width: 266px;
    height: 64px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.15px;
    font-size: 1.6rem;
  }

  .profiles_process_divider {
    position: absolute;
    right: -58%;
    width: 15rem;
    border: 2px dashed #34a853;
  }

  @media screen and (max-width: 1100px) {
    .traditional_process_text {
      width: 200px;
    }

    .traditional_process_divider {
      position: absolute;
      right: 10rem;
      bottom: -4.1rem;
      width: 0rem;
      height: 4rem;
      border: 2px dashed #34a853;
    }

    .traditional_process {
      display: grid;
      grid-template-columns: 1fr;
      gap: 4rem;
      justify-items: center;
    }

    .profiles_process {
      display: grid;
      grid-template-columns: 1fr;
      gap: 4rem;
      justify-items: center;
    }

    .profiles_process_text {
      width: 200px;
    }

    .profiles_process_divider {
      position: absolute;
      right: 10rem;
      bottom: -4.1rem;
      width: 0rem;
      height: 4rem;
      border: 2px dashed #34a853;
    }

    .profiles_process_wrapper h3 {
      font-size: 2.4rem;
      font-weight: 700;
      text-align: center;
      width: auto;
    }
  }
`;

export default HiringProcess;
